import { fetchZipCityCountyRegion } from "@/services/configService";

export async function zipCityCountyConfigAction() {

    try {
        const fetchData = await fetchZipCityCountyRegion(); // call the configService to fetch data from api
        // if (fetchData) {
        //     context.SET_SEARCH_DATA(fetchData)
        // }
        return fetchData;

    } catch (error) {
        console.log(`Error in fetching ZipCityCounty config data ${error}`);
    }
}

export const filterCountyLocationAction = async ( locationSearchString, filterdata) => {
    try {
        const params = new URLSearchParams(locationSearchString);
        const county = params.get("county");
        const finalObject = filterdata.find(item => (item.f === "county" && item.l.toUpperCase() === (`${county} County`).toUpperCase()))
        const filteredCountyData = finalObject ? { County: finalObject.l.replace(" County", ""), Lat: finalObject.a, Long: finalObject.o } : null;
        // if (filteredCountyData) {
        //     context.SET_USER_LOCATION(filteredCountyData);
        // }
        return filteredCountyData
    } catch (error) {
        console.log(`Error while loading county map: ${error}`)
    }
}